module.exports = __webpack_public_path__ + "img/1.e92cc7b3.svg";